module.exports = __webpack_public_path__ + "img/Legal-Naija-Logo.11e6644c.jpeg";